import { SORT_RECENT, SORT_MATCHING } from '../../constants/search';

const EXCLUDED_QUERY_KEYS = ['page'];

const isKeyNotExcluded = (value) => {
  return !EXCLUDED_QUERY_KEYS.includes(value);
};

const isValidPaginationOptions = (options) => {
  return options.resultsPerPage > 0;
};

const calculatePaginatedCursor = (page, options) => {
  if (!page || page < 1) {
    return null;
  }

  return (page - 1) * options.resultsPerPage;
};

const addPaginationToQuery = (query, params, options) => {
  if (!isValidPaginationOptions(options)) {
    return;
  }
  const paginatedCursor = calculatePaginatedCursor(params.page, options);
  if (paginatedCursor !== null) {
    query.cursor = paginatedCursor;
  }

  query.size = options.resultsPerPage;
};

const addCursorToQuery = (query, options) => {
  if (options.cursor) {
    query.cursor = JSON.parse(options.cursor); // cursor is a string not an object
  }
};

const addSortingToQuery = (query, options) => {
  if (query.sortBy) {
    return;
  }

  if (query.q) {
    query.sortBy = SORT_MATCHING;
    return;
  }

  query.sortBy = options.defaultSortBy || SORT_RECENT;

  if (options.defaultSortOrder) {
    query.sortOrder = options.defaultSortOrder;
  }
};

const buildSearchQuery = (params, options) => {
  const query = Object.keys(params).filter(isKeyNotExcluded).reduce((query, key) => {
    query[key] = Array.isArray(params[key])
      ? params[key].join(',')
      : params[key];
    return query;
  }, {});

  if (options.isPaginated) {
    addPaginationToQuery(query, params, options);
  } else {
    addCursorToQuery(query, options);
  }

  addSortingToQuery(query, options);
  return query;
};

export default buildSearchQuery;
